import { render, staticRenderFns } from "./HraRiskSummaryCard.vue?vue&type=template&id=f5e875d0"
import script from "./HraRiskSummaryCard.vue?vue&type=script&lang=js"
export * from "./HraRiskSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports